module.exports = __webpack_public_path__ + "img/新人专场.8f82d502.svg";